<template>
    <v-snackbar
        :timeout="snackbarTimeout"
        :top="snackbarY === 'top'"
        :bottom="snackbarY === 'bottom'"
        :right="snackbarX === 'right'"
        :left="snackbarX === 'left'"
        :multi-line="snackbarMode === 'multi-line'"
        :vertical="snackbarMode === 'vertical'"
        :color="snackbarContext"
        v-model="show"
    >
        <span v-html="snackbarMessage"></span>
        <v-btn icon @click.native="closeSnackbar()">
            <v-icon>
                mdi-close
            </v-icon>
        </v-btn>
    </v-snackbar>
</template>

<script>
export default {
    data() {
        return {
            show: false
        }
    },
    computed: {
        snackbarTimeout() {
            return this.$store.state.snackbarTimeout
        },
        snackbarX() {
            return this.$store.state.snackbarX
        },
        snackbarY() {
            return this.$store.state.snackbarY
        },
        snackbarMode() {
            return this.$store.state.snackbarMode
        },
        snackbarMessage() {
            return this.$store.state.snackbarMessage
        },
        snackbarContext() {
            return this.$store.state.snackbarContext
        }
    },
    methods: {
        closeSnackbar() {
            this.$store.commit('closeSnackbar')
        }
    },
    created: function() {
        this.$store.watch(
            state => state.callSnackbar,
            () => {
                if (this.$store.state.callSnackbar !== 0) {
                    this.show = true
                } else {
                    this.show = false
                }
            }
        )
    }
}
</script>
